import { Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { getAvailableLanguages } from 'utils/utils';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { DetailsControlComponent } from 'shared/details-page/details-control/details-control.component';
import * as _ from 'lodash';
import { DetailsControlType } from 'shared/details-page/details-control/details-control-type';
import { descriptionSegmentData } from '../../product-details-v2/segment-data/description-segment-data';
import {SegmentFieldItem} from 'utils/segment-field-item.interface';

interface Language {
  title: string;
  active: boolean;
  code: string;
}
interface SpecificDescriptionList {
  [key: string]: Array<string>;
}
interface Descriptions {
  [key: string]: SpecificDescriptionList;
}

@Component({
  moduleId: module.id,
  selector: 'asset-descriptions',
  templateUrl: 'asset-descriptions.component.html',
  styleUrls: ['asset-descriptions.component.scss'],
})
export class AssetDescriptionsComponent implements OnInit, OnChanges {
  languages: Array<Language> = [];
  selectedLanguage: string = 'EN';

  label: string = 'Description';
  fieldMap: string = 'description';

  typeLabel: string = 'Description type';
  defaultType: string = 'CAP';

  componentFormArray: UntypedFormArray;
  componentDescriptionsFormArray: UntypedFormArray;
  componentDescriptionTypesFormArray: UntypedFormArray;

  componentFormValue: Descriptions = null;
  descriptionSegmentData: Array<SegmentFieldItem> = descriptionSegmentData;

  @ViewChildren(DetailsControlComponent)
  detailsControls: QueryList<DetailsControlComponent>;

  @Input() formValue: Descriptions = null;

  @Output() changeForm  = new EventEmitter<Descriptions>();

  descriptionsLookup: Array<{
    option: string,
    title: string,
  }> = [
    {
      'option': 'CAP',
      'title': 'Caption'
    },
    {
      'option': 'TLE',
      'title': 'Title Description'
    },
    {
      'option': 'SHO',
      'title': 'Short description'
    },
    {
      'option': 'DES',
      'title': 'Long description'
    },
    {
      'option': 'EXT',
      'title': 'Extended description'
    },
    {
      'option': 'LAB',
      'title': 'Label description'
    },
    {
      'option': 'FAB',
      'title': 'Features and Benefits'
    },
    {
      'option': 'INV',
      'title': 'Invoice description'
    },
    {
      'option': 'ASM',
      'title': 'Application summary'
    },
    {
      'option': 'ASC',
      'title': 'Associated comments'
    },
    {
      'option': 'MKT',
      'title': 'Marketing description'
    },
    {
      'option': 'ABR',
      'title': 'Abbreviated description'
    },
    {
      'option': 'KEY',
      'title': 'Key search words'
    },
    {
      'option': 'SHP',
      'title': 'Shipping restrictions'
    },
    {
      'option': 'SLA',
      'title': 'Slang description'
    },
    {
      'option': 'UNS',
      'title': 'UN/SPSC description'
    },
    {
      'option': 'VMR',
      'title': 'VMRS description'
    },
    {
      'option': 'TRA',
      'title': 'Transcription'
    },
    {
      'option': 'MTP',
      'title': 'Market Type'
    },
    {
      'option': 'DEF',
      'title': 'AAIA Part Type Description'
    },
  ];

  @Input() editMode: boolean;

  constructor(
    private fb: UntypedFormBuilder,
  ) {
  }

  ngOnInit() {
    this.languages = getAvailableLanguages();
  }

  ngOnChanges() {
    this.componentFormValue = {...this.formValue};
    this.setFormArray();
  }

  onLanguageChange(lang: Language) {
    this.selectedLanguage = lang.code;
    this.setFormArray();
  }

  getComponentFormArray(): UntypedFormArray {
    return this.componentFormArray;
  }

  getComponentDescriptionsFormArray(): UntypedFormArray {
    return this.componentDescriptionsFormArray;
  }

  getComponentDescriptionTypesFormArray(): UntypedFormArray {
    return this.componentDescriptionTypesFormArray;
  }

  getItemValidation(item) {
    const validation = this.descriptionSegmentData.find(s => s.field_map === item?.value?.key?.toLowerCase())?.validation?.pies65;
    return validation;
  }

  setFormArray() {
    const formArrayValue: Object = this.componentFormValue;
    const formArray: Array<{key: string, value: string}> = [];

    Object.keys(formArrayValue).forEach(key => {
      const values = formArrayValue[key][this.selectedLanguage];
      if (!values) {
        return;
      }
      values.map(value => {
        formArray.push({
          key,
          value,
        });
      });
    });

    if (formArray.length === 0) {
      formArray.push({
        key: '',
        value: '',
      });
    }

    if (_.isEqual(this.componentFormArray?.value, formArray)) {
      return;
    }

    this.componentFormArray = this.fb.array(formArray);

    const formValue = this.componentFormArray.value.map(i => i.value);
    const formKeys = this.componentFormArray.value.map(i => i.key);
    this.componentDescriptionsFormArray = this.fb.array(formValue);
    this.componentDescriptionTypesFormArray = this.fb.array(formKeys);
  }

  updateForm() {
    const formArrayValue = this.componentFormArray.value;
    const form = {};
    formArrayValue.map(item => {
      if (!form[item.key]) {
        form[item.key] = {};
        form[item.key][this.selectedLanguage] = [item.value];
      } else if (!form[item.key][this.selectedLanguage]) {
        form[item.key][this.selectedLanguage] = [item.value];
      } else {
        form[item.key][this.selectedLanguage].push(item.value);
      }
    });
    this.languages.map(lang => {
      if (lang.code === this.selectedLanguage) {
        return;
      }
      for (const item in this.componentFormValue) {
        if (this.componentFormValue.hasOwnProperty(item)) {
          if (this.componentFormValue[item][lang.code]) {
            form[item][lang.code] = this.componentFormValue[item][lang.code];
          }
        }
      }
    });
    this.changeForm.emit(form);
  }

  onLoopingControlStatusChange(status: any, index: number) {
    // this.scorecardConnectorService.controlStatusChanged.emit({
    //   status, item, index, language: this.selectedLanguage
    // });
  }
  onLoopingControlFocus(index: number) {
    // this.scorecardConnectorService.controlFocused.emit({
    //   item, index, language: this.selectedLanguage
    // });
  }
  onLoopingControlBlur(index: number) {
    this.updateForm();
  }
  onTextPopulatedChange(populated: number, index: number) {
    // this.scorecardConnectorService.controlPopulatedChanged.emit({
    //   populated, item, index, language: this.selectedLanguage
    // });
  }

  onDeleteControlClick(control: AbstractControl) {
    const formArray: any = this.getComponentFormArray();
    if (!formArray) { return console.warn('formArray not found!'); }
    const index = formArray.controls.indexOf(control);
    formArray.removeAt(index);

    this.updateForm();

    // this.scorecardConnectorService.controlRemoved.emit({
    //   item, index, language: this.selectedLanguage,
    // });
    // this.markAsDirty();
  }

  onAddAnotherClick() {
    // const validators: any = this.getFieldValidators(item);
    const formArrayValue = this.componentFormArray.value;
    formArrayValue.push({
      key: '',
      value: '',
    });
    this.componentFormArray = this.fb.array(formArrayValue);

    const formValue = this.componentFormArray.value.map(i => i.value);
    const formKeys = this.componentFormArray.value.map(i => i.key);
    this.componentDescriptionsFormArray = this.fb.array(formValue);
    this.componentDescriptionTypesFormArray = this.fb.array(formKeys);

    this.updateForm();

    // this.scorecardConnectorService.controlAdded.emit({
    //   item, index: formArray.length - 1, language: this.selectedLsanguage,
    // });
    // _.defer(() => {
    //   this.focusOnLastLoopingControl(item.field_map);
    //   this.markAsDirty();
    // });
  }

  onControlValueChanged(value: string, index: number) {
    const control = this.componentFormArray.controls[index];
    const controlValue = control.value;
    if (!controlValue.key) {
      this.onControlTypeChanged(this.defaultType, index);
      const formKeys = this.componentFormArray.value.map(i => i.key);
      this.componentDescriptionTypesFormArray = this.fb.array(formKeys);
    }
    control.setValue({
      key: controlValue.key || this.defaultType,
      value: value,
    });
    this.updateForm();
    _.defer(() => {
        this.detailsControls.filter(el => el.controlType === DetailsControlType.Textarea)[index].focusControl(this.fieldMap);
      }
    );
  }

  onControlTypeChanged(type: string, index: number) {
    const control = this.componentFormArray.controls[index];
    const controlValue = control.value;
    control.setValue({
      ...controlValue,
      key: type,
    });
    this.updateForm();
  }
}
